import { render, staticRenderFns } from "./exhibition-photos.vue?vue&type=template&id=3f9e6519&scoped=true&"
import script from "./exhibition-photos.vue?vue&type=script&lang=js&"
export * from "./exhibition-photos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9e6519",
  null
  
)

export default component.exports